/**
 * Strings of the visual overhaul's WP3 (kit, overlays)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one.
 */
import type { Dict } from '../core';

export const kitEn: Dict = {};
